var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 0.576996C11.8643 0.576996 0 12.4413 0 27.077C0 41.7127 11.8643 53.577 26.5 53.577C41.1357 53.577 53 41.7127 53 27.077C53 12.4413 41.1357 0.576996 26.5 0.576996ZM39.7467 37.9828L37.4036 40.3237L26.5 29.4211L15.5975 40.3237L13.2533 37.9828L24.1581 27.0781L13.2533 16.1733L15.5941 13.8303L26.5 24.7362L37.407 13.8303L39.7467 16.1733L28.843 27.0781L39.7467 37.9828Z",
    fill: "#F64B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2c3306a017198ec28d7db9bc27367f62.svg";
export { ForwardRef as ReactComponent };